import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import ProjectDeepLink from "../../components/ProjectDeepLink";

const ProtectedRoute = (props: {
  children:
    | string
    | number
    | boolean
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | React.ReactFragment
    | React.ReactPortal
    | null
    | undefined;
}) => {
  const location = useLocation();
  const userToken = localStorage.getItem("token");
  const isLoggedIn = Boolean(userToken && userToken !== "undefined");
  const projectId = new URLSearchParams(location.search).get("p");
  const isProjectEntry = ["/", "/app", "/concept-one"].includes(location.pathname);

  return isLoggedIn
    ? projectId && isProjectEntry
      ? <ProjectDeepLink key={projectId} projectId={projectId} />
      : <React.Fragment>{props.children}</React.Fragment>
    : <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />;
};
export default ProtectedRoute;
